import { FaChevronDown } from 'react-icons/fa';

const CollapsibleGroup = ({ label, isOpen, onToggle, children, testId }) => (
  <li className="te-mobile-menu-group">
    <button
      type="button"
      className="te-mobile-menu-group-trigger te-focus-ring-inset"
      aria-expanded={isOpen}
      onClick={onToggle}
      data-testid={testId}
    >
      {label}
      <FaChevronDown className={`te-mobile-menu-chevron ${isOpen ? 'open' : ''}`} />
    </button>

    {isOpen && <div className="te-mobile-menu-panel">{children}</div>}
  </li>
);

export default CollapsibleGroup;
